export default "__VITE_ASSET__bd8iP8fq__"